import React from 'react'
import { Aside, Button, Heading, Link, VerticalSpacer } from '@superhi/design'

import { buildPath } from '../../../../../../routing/utils'

import { Wrapper, Items, CurrentWrapper } from './styles'

const MAX_POSTS = 6

type Post = {
  title: string
  slug: string
}

type Props = {
  slug: string
  posts: Post[]
  currentPostSlug: string
}

const SeriesList: React.FC<Props> = ({ slug, currentPostSlug, posts = [] }) => (
  <Wrapper data-component-name="Series">
    <Aside label="Also in this series" level="2">
      <VerticalSpacer>
        <Items>
          {posts.slice(0, MAX_POSTS).map((item) =>
            currentPostSlug === item.slug ? (
              <CurrentWrapper key={item.slug}>
                <Heading level="5">{item.title}</Heading>
              </CurrentWrapper>
            ) : (
              <Link
                key={item.slug}
                href={buildPath('posts-view', { params: { postSlug: item.slug } })}
                color="GREY_90"
                hoverColor="BLUE_50"
              >
                <Heading level="5">{item.title}</Heading>
              </Link>
            ),
          )}
        </Items>
        {posts.length > MAX_POSTS && (
          <Button
            href={buildPath('series-view', { params: { seriesSlug: slug } })}
            version="outline"
            fullWidth
          >
            View all {posts.length} posts
          </Button>
        )}
      </VerticalSpacer>
    </Aside>
  </Wrapper>
)

export default SeriesList
